
import { Injectable } from '@angular/core';
import { Tarification } from '../interfaces/tarification';
import { RestApiService } from './rest-api.service';

@Injectable({
    providedIn: 'root'
})
export class TarificationService {

    public tarification: Array<Tarification> = [];

    constructor(
        private api: RestApiService
    ) { }

    getTarification(): Promise<any> {
        // return 10;

        return new Promise((resolve, reject) => {
            let query: any = {};

            resolve(true);
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetStationsVOPCount', query, true).then((res) => {
                resolve(res);
            });
        });
    };

    getTarificationByVehicle(id): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};

            this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/price?idVehicle=' + id, query, false).then((res) => {
                resolve(res);
            });
        });
    };

    updateTarificationByVehicle(price): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};
            query = price;
            console.log(query);

            this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/price', query, false).then((res) => {
                console.log(res)
                resolve(res);
            });
        });
    };

    updateTarificationByVehicleArray(price): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};
            query = price;
            console.log(query);

            this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle-list/price', query, false).then((res) => {
                console.log(res)
                resolve(res);
            }).catch((err) => {
                console.log(err)
                reject(err);
            });
        });
    };

    updateVehicles(query): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetVehiclesVOP', query, true).then((res) => {

                resolve(res);
            });
        });
    };
}
